import { Check } from "lucide-react";

const PHASES = [
  { n: "01", label: "Phase 1", title: "Referral Pilot", accent: "#0A8B85",
    items: ["Co-branded campaign page, Clinq-hosted", "Qualified members referred to the SACCO directly",
      "Designated credit liaison at the SACCO", "Agreed go/no-go turnaround SLA", "No system integration required"] },
  { n: "02", label: "Phase 2", title: "Embedded Infrastructure", accent: "#E3B84C",
    items: ["Clinq's scoring and DSCR engine exposed via API", "Embedded directly into the SACCO's own member journey",
      "Fully SACCO-branded member experience", "SACCO's own transaction data feeds scoring", "Post-disbursement monitoring layer available"] },
];

export const SaccoPhases = () => (
  <section className="mx-auto max-w-6xl px-5 py-20 sm:py-24" data-testid="sacco-phases">
    <h2 className="max-w-3xl text-2xl font-extrabold text-[#0B2A28] sm:text-3xl" data-testid="sacco-phases-heading">
      From Referral Pilot to Embedded Infrastructure
    </h2>
    <div className="mt-10 grid gap-6 md:grid-cols-2">
      {PHASES.map(({ n, label, title, accent, items }, i) => (
        <div key={n} className="relative overflow-hidden rounded-3xl border border-neutral-200 bg-white p-8 shadow-sm sm:p-10" data-testid={`sacco-phase-${i + 1}`}>
          <span className="pointer-events-none absolute -right-2 -top-6 select-none text-[120px] font-extrabold leading-none" style={{ color: accent, opacity: 0.08 }}>{n}</span>
          <span className="text-[11px] font-extrabold uppercase tracking-[0.22em]" style={{ color: accent === "#E3B84C" ? "#8A6A1E" : accent }}>{label}</span>
          <p className="mt-2 text-xl font-extrabold text-[#0B2A28] sm:text-2xl">{title}</p>
          <ul className="mt-7 space-y-3">
            {items.map((t) => (
              <li key={t} className="flex gap-3 text-sm text-neutral-700 sm:text-base">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-white" style={{ backgroundColor: accent }}>
                  <Check size={12} strokeWidth={3} />
                </span>
                {t}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  </section>
);
